import { http } from '@/plugins/http';
import { getData } from '@/utils/get';

class VpnCustomer {
  get = () => http.post('vpn-customers', []).then(getData);
}

export default new VpnCustomer();
